import { useContext } from 'react';
import context, { CollapseProps } from './CollapseContext';

export default function useCollapseContext(): CollapseProps {
  return useContext(context);
}
